import React, { Fragment, PropsWithChildren } from "react";

import { Button, styled, Grid } from "@mui/material";

import { Card, CardContent, Typography, Divider } from "./StyledComponents";

const StyledCardContent = styled(CardContent)`
  & .MuiToolbar-root {
    min-height: 0;
  }
`;

const CardTitle = styled(Typography)`
  font-weight: 600;
  color: #1a3a5c;
  font-size: 0.9375rem;
  line-height: 1.3;
`;

interface Action {
  icon?: string;
  onClick?: () => any;
  title: string;
}

interface InfoCardProps {
  actions?: Array<Action>;
  title?: string;
}

export const InfoCard = ({
  children,
  actions,
  title,
}: PropsWithChildren<InfoCardProps>) => {
  return (
    <Card mb={6}>
      <StyledCardContent>
        <Grid container spacing={6} justifyContent="space-between" alignItems="center">
          <Grid item>
            <CardTitle variant="h6">
              {title}
            </CardTitle>
          </Grid>
          <Grid item>
            {actions &&
              actions.map((a) => (
                <Fragment key={a.title}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => {
                      a.onClick && a.onClick();
                    }}
                  >
                    {a.title}
                  </Button>
                </Fragment>
              ))}
          </Grid>
        </Grid>
        <Divider my={3} />
        {children}
      </StyledCardContent>
    </Card>
  );
};
